import { createElement as e, useMemo } from 'react';
import { RemarkContext } from './context';
import { ClientOptions, initialize } from '@outdoorly/chat-sdk';

export type RemarkProviderProps = ClientOptions;
export const RemarkProvider: React.FC<RemarkProviderProps> = ({ children, ...options }) => {
  const client = useMemo(() => initialize(options), []);
  return e(RemarkContext.Provider, { value: { client, inProvider: true } }, children);
};
